import { Header } from '@anytag/shared-molecules';
import { TikTokSpecialCampaignDetail } from '@anytag/graphql';
import { TikTokCampaignStatus } from '../TikTokCampaignStatus';
import { RejectButton } from './RejectButton';
import { ApproveButton } from './ApproveButton';

export interface TikTokCampaignHeaderProps {
  tiktokSpecialCampaign?: TikTokSpecialCampaignDetail;
}

export const TikTokCampaignHeader = ({ tiktokSpecialCampaign }: TikTokCampaignHeaderProps) => (
  <Header>
    <TikTokCampaignStatus status={tiktokSpecialCampaign?.status} />

    <RejectButton tiktokSpecialCampaign={tiktokSpecialCampaign} className="ml-auto" />
    <ApproveButton tiktokSpecialCampaign={tiktokSpecialCampaign} />
  </Header>
);
